import { Module } from "../models/module.model";

/**
 * Configuration for all modules in O2 ERP
 */
export const MODULES_CONFIG: Module[] = [
  {
    id: "planning",
    label: "Pianifica",
    path: "/planning",
    pages: [
      {
        id: "projects",
        label: "Progetti",
        icon: "lucideFilePen",
        path: "projects",
      },
      {
        id: "planning",
        label: "Pianificazione",
        icon: "lucidePencilRuler",
        path: "planning",
      },
      {
        id: "schedule",
        label: "Schedule",
        icon: "lucideChartNoAxesGantt",
        path: "schedule",
      },
      {
        id: "activities",
        label: "Attività",
        icon: "lucideTrello",
        path: "activities",
      },
      { id: "stamps", label: "Timbri", icon: "lucideStamp", path: "stamps" },
      {
        id: "timesheets",
        label: "Rapportini",
        icon: "lucideFiles",
        path: "timesheets",
      },
    ],
  },
  {
    id: "sales",
    label: "Vendi",
    path: "/sales",
    pages: [
      {
        id: "contacts",
        label: "Contatti",
        icon: "lucideUsers",
        path: "contacts",
      },
      { id: "quotes", label: "Preventivi", icon: "lucideEuro", path: "quotes" },
      {
        id: "contracts",
        label: "Contratti",
        icon: "lucideFileText",
        path: "contracts",
      },
    ],
  },
  {
    id: "analytics",
    label: "Analizza",
    path: "/analytics",
    pages: [
      {
        id: "margin",
        label: "Margine",
        icon: "lucideTrendingUp",
        path: "margin",
      },
      {
        id: "production-analysis",
        label: "Analisi Produzione",
        icon: "lucideChartBar",
        path: "production-analysis",
      },
      {
        id: "workload",
        label: "Carico di Lavoro",
        icon: "lucideBatteryMedium",
        path: "workload",
      },
      {
        id: "sal",
        label: "SAL",
        icon: "lucidePercent",
        path: "sal",
      },
      {
        id: "timesheets",
        label: "Analisi Rapportini",
        icon: "lucideClipboardClock",
        path: "timesheets",
      },
    ],
  },
  {
    id: "admin",
    label: "Amministra",
    path: "/admin",
    pages: [
      {
        id: "price-lists",
        label: "Gestione Listini",
        icon: "lucideFolders",
        path: "price-lists",
      },
      {
        id: "standard-tasks",
        label: "Task Standard",
        icon: "lucideFileText",
        path: "standard-tasks",
      },
      { id: "users", label: "Utenti", icon: "lucideUsers", path: "users" },
    ],
  },
];
